import { LookupTables } from "@/models/lookup-tables/lookup-tables.dto";
import { createSlice } from "@reduxjs/toolkit";
import { fetchLookupTables, fetchVendors } from "./common.thunks";

interface InitialState {
	error: string;
	lookupTables?: LookupTables;
	isLookupTablesLoading?: boolean;
	vendors: any;
}

const initialState: InitialState = {
	error: "",
	lookupTables: undefined,
	vendors: undefined,
};

export const commonReducer = createSlice({
	name: "@common",
	initialState,
	reducers: {
		setLTError(state, action) {
			state.error = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLookupTables.fulfilled, (state, action) => {
				if (action.payload.error) {
					state.error = action.payload.message;
				} else {
					state.lookupTables = action.payload.data;
					state.isLookupTablesLoading = false;
				}
			})
			.addCase(fetchLookupTables.pending, (state, action) => {
				state.isLookupTablesLoading = true;
			})
			.addCase(fetchVendors.fulfilled, (state, action) => {
				state.vendors = action.payload;
			});
	},
});

export const { setLTError } = commonReducer.actions;
